import { OptionTitle } from "./OptionTitle"

export const PreservationChoices: Array<OptionTitle> = [
  { title: "Preserving sperm", id: "PRESERVE_SPERM" },
  { title: "Preserving eggs", id: "PRESERVE_EGGS" },
  { title: "Preserving embryos", id: "PRESERVE_EMBRYOS" },
  { title: "Preserving both eggs/embryos and sperm", id: "PRESERVE_EGGS_EMBRYOS_OR_SPERM" }
]
